import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useAuth } from '../auth';
import { initDataDog } from './initDataDog';

interface Props {
    children: React.ReactNode;
}

export const DataDogProvider = ({ children }: Props) => {
    const { user } = useAuth();

    useEffect(() => {
        if (user) {
            datadogRum.setUser({
                id: user.sub,
                email: user.email,
                name: user.name,
                plan: user.planGroup,
            });
        }
    }, [user]);

    useEffect(() => {
        initDataDog();
    }, []);

    return <>{children}</>;
};
